/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 連携タイミング
 */
export type BaseInfoCollaborationTimingEnum =
  (typeof BaseInfoCollaborationTimingEnum)[keyof typeof BaseInfoCollaborationTimingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoCollaborationTimingEnum = {
  BEFORE_CONTACT: 'BEFORE_CONTACT',
  AFTER_CONTACT: 'AFTER_CONTACT',
} as const;
